import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../../Baseurl";

const AddMainCategorySub = () => {
  const [categoryName, setCategoryName] = useState("");
  const [categoryImage, setCategoryImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  // Handle Image Selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setCategoryImage(file);

    // Create a preview URL
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setPreviewImage(previewURL);
    } else {
      setPreviewImage(null);
    }
  };

  // Handle Form Submission (Add New Category)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("category_name", categoryName);
    if (categoryImage) {
      formData.append("category_image", categoryImage);
    }

    try {
      await axios.post(`${baseurl}AddCategory`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        title: "Success!",
        text: "Category added successfully.",
        icon: "success",
        confirmButtonText: "Ok",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        title: "Error!",
        text: "There was an error saving the category.",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  return (
    <>
      {/* 🔹 Button to open modal */}
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#addCategoryModal"
      >
        Add Sub Category
      </button>

      {/* 🔹 Bootstrap Modal */}
      <div
        className="modal fade"
        id="addCategoryModal"
        tabIndex="-1"
        aria-labelledby="addCategoryModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addCategoryModalLabel">
                Add New Category
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                {/* Category Name */}
                <div className="mb-3 text-start">
                  <label htmlFor="categoryName" className="form-label">
                    Category Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="categoryName"
                    placeholder="Enter Category Name..."
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                    required
                  />
                </div>

                {/* Category Image Upload */}
                <div className="mb-3 text-start">
                  <label htmlFor="categoryImage" className="form-label">
                    Upload Category Image (Optional)
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="categoryImage"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </div>

                {/* Preview Selected Image */}
                {previewImage && (
                  <div className="mb-3 text-start">
                    <img
                      src={previewImage}
                      alt="Preview"
                      style={{ width: "150px", height: "auto", borderRadius: "5px" }}
                    />
                  </div>
                )}

                <div className="text-end">
                  <button type="submit" className="btn btn-success">
                    Add Category
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMainCategorySub;
